export const ALLOWED_PROGRAMS = ['pipeline', 'carousel'];

export const SUB_TYPES = {
  pipeline: 'a1',
  carousel: 'a2'
};
